export var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus["COMPLETE"] = "COMPLETE";
    AuthenticationStatus["PENDING_METHOD_SELECTION"] = "PENDING_METHOD_SELECTION";
    AuthenticationStatus["PENDING"] = "PENDING";
    AuthenticationStatus["PENDING_CHALLENGE"] = "PENDING_CHALLENGE";
    AuthenticationStatus["CHALLENGE_FAILED"] = "CHALLENGE_FAILED";
    AuthenticationStatus["CANCELLED"] = "CANCELLED";
    AuthenticationStatus["EXPIRED"] = "EXPIRED";
    AuthenticationStatus["NOT_SUPPORTED"] = "NOT_SUPPORTED";
})(AuthenticationStatus || (AuthenticationStatus = {}));
//# sourceMappingURL=AuthenticationStatus.js.map